import React from 'react';
import Slider from 'rc-slider';

/*
 * Slider component based on https://github.com/react-component/slider.
 *
 * @author: Nathan Ozelim <nathan@startupfoundry.com>
*/

const CsHandle = ({ className, vertical, offset, handleStyle, value, ...restProps }) => {
  const style = vertical? { bottom: `${offset}%` } : { left: `${offset}%` };

  return (
    <div className={className} style={{...style, ...handleStyle}}>
      <h4><span className="dollar-sign">$</span>{ value }</h4>
    </div>
  );
};

const CsSlider = (props) => <Slider {...props} handle={props.handle || CsHandle}/>

export default CsSlider;
